<div
	#popoverPanel
	class="go-cdk-popover-panel"
	[ngClass]="panelClass"
	[ngStyle]="panelStyle"
	[cdkTrapFocus]="shouldTrapFocus"
	[cdkTrapFocusAutoCapture]="shouldTrapFocus"
	[attr.aria-hidden]="!isVisible"
	[attr.aria-labelledby]="isInteractive ? id + '-title' : null"
	[attr.aria-describedby]="isInteractive ? null : id"
	[attr.id]="id">
	@if (title || showCloseButton) {
		<div class="go-cdk-popover-header">
			@if (title) {
				<div class="go-cdk-popover-title">
					@if (titleIcon) {
						<i [class]="titleIcon" [style.color]="titleIconColor"></i>
					}
					{{ title | translate }}
				</div>
			}
			@if (showCloseButton) {
				<button
					#closeButton
					class="go-cdk-popover-close"
					type="button"
					[attr.aria-label]="closeButtonAriaLabel"
					(click)="close()">
					<i class="ficon-app-x"></i>
				</button>
			}
		</div>
	}
	<div class="popover-scroll">
		<div class="go-cdk-popover-content">
			@if (contentTemplate) {
				<ng-container *ngTemplateOutlet="contentTemplate; context: context"></ng-container>
			} @else if (!contentTemplate && contentText) {
				<div [innerHTML]="contentText"></div>
			} @else if (contentComponent) {
				<ng-container *ngTemplateOutlet="componentTemplate"></ng-container>
			}
		</div>
	</div>
	@if (showArrow) {
		<div class="go-cdk-popover-arrow" [ngClass]="arrowPosition" [ngStyle]="arrowStyle"></div>
	}
</div>
<ng-template #componentTemplate></ng-template>
